/**
 * The trailing-window picker: same shape as `../accounts/Account.tsx`'s own `useTrailingWindow`
 * (a wall-clock-relative span computed from "now", not from the previous window), just with the
 * day count exposed as a control instead of the account screen's fixed 7.
 */

import type { ReactNode } from 'react';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../ui/select';
import { dm } from './messages';

export const WINDOW_DAY_OPTIONS = [7, 14, 30] as const;
export type WindowDays = (typeof WINDOW_DAY_OPTIONS)[number];

export function WindowSelect(props: {
  value: WindowDays;
  onChange: (days: WindowDays) => void;
}): ReactNode {
  return (
    <Select
      value={String(props.value)}
      onValueChange={(next) => props.onChange(Number(next) as WindowDays)}
    >
      <SelectTrigger aria-label={dm('window.label')} size="sm" className="w-44">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {WINDOW_DAY_OPTIONS.map((days) => (
          <SelectItem key={days} value={String(days)}>
            {dm(`window.${days}d` as 'window.7d' | 'window.14d' | 'window.30d')}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
